/*============================================================================
  #Noisin Custom Hoila JS
==============================================================================*/  
$(document).ready(function(){
  $('.slick-track').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    accessibility:true,
  asNavFor:null,
  prevArrow:'<button type="button" data-role="none" class="slick-prev">Previous</button>',
  nextArrow:'<button type="button" data-role="none" class="slick-next">Next</button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
});

function mouseOverOverLay() {
  document.getElementById("noisin-content-overlay").style.opacity = "0.25";
  document.getElementById("noisin-content-overlay").style.height = "100vh";
}

function mouseOutOverLay() {
  document.getElementById("noisin-content-overlay").style.opacity = "0";
  document.getElementById("noisin-content-overlay").style.height = "0";
}

function readLess() {
  var element = document.getElementById("tab-content");
  element.classList.remove("is-visible");
  element.classList.add("is-expanded");
}